export const project_query = {
  include_archived: false,
  max_rows: 100,
  filter: '',
  created_by: null,
};
